import { defineComponent as _defineComponent } from 'vue'
import Button from '~/src_common/components/parts/button/Button.vue';

// isDesktop はグローバル mixin（src/main.js=true, src_sp/main.js=false）を
// テンプレートで直接参照する（CompleteStepper.vue・AppDownloadBanner.vue と同様のパターン）。
// Figma実測値（PC node 1811:32733 root 1811:32732 / SP node 1811:32777）でコンテナの
// gap・paddingがPC/SPで異なることを確認済み:
//   PC: gap-[16px] px-[32px] py-[16px]
//   SP: gap-[12px] px-[16px] pt-[12px] pb-[20px]
// 見出しは完了画面で白箱が並ぶため、AppDownloadBanner・CompleteMypageSection と
// 同一サイズ（PC text-base / SP text-sm）に揃えている（Figma の単独配置時より小さい）。
// 色は青ではなく text-ink。青見出しは AppDownloadBanner のような訴求セクションに限る。
// ボタン・注意書きのスタイルはPC/SPで同一（両nodeで一致確認済み）。
// props/emitを持たない静的コンポーネント。ボタンの遷移先は /contact/form
// （Header.vue/HeaderSp.vueの/contactとは異なる、お問い合わせフォーム専用パス）。

export default /*#__PURE__*/_defineComponent({
  __name: 'CompleteContactCta',
  setup(__props) {


return { __sfc: true,Button }
}

})